import * as St from './index.styled';
import { useEffect, useRef, useState } from "react";
import { useApiInfoContextValueHook } from "../../../contexts/ApiInfoContextProvider";
import axios from "axios";
import { SellertoolSignatureUtils } from "../../../utils/sellertool-signature-utils";
import { customToast } from "../../../components/toast/custom-react-toastify/v1";
import CustomBlockButton from '../../../components/button/CustomBlockButton';
import { useNavigate } from 'react-router-dom';
import { useQueryParamsHook } from '../../../hooks/useQueryParamsHook';
import { CustomLabelInput } from '../../../components/input/CustomLabelInput';
import { CustomBackdropController } from '../../../components/backdrop/default/v1';
import { CustomDialog } from '../../../components/dialog/v1/CustomDialog';
import { VibrationUtils } from '../../../utils/vibration-utils';
import { CustomDateUtils } from '../../../utils/custom-date-utils';

const API_HOST = process.env.REACT_APP_MAIN_API_HOST;

export const MainView = () => {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const queryParamsHook = useQueryParamsHook();
    const currentStageUUID = queryParamsHook?.params?.stage;

    const [currentStage, setCurrentStage] = useState(null);
    const [warehousingItems, setWarehousingItems] = useState(null);

    const [scanModalOpen, setScanModalOpen] = useState(false);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [targetWaybill, setTargetWaybill] = useState(null);

    useEffect(() => {
        if (currentStageUUID) {
            const timestamp = Date.now().toString();
            const signature = SellertoolSignatureUtils().generateSigniture({
                apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
                secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
                timestamp: timestamp
            });

            const headers = {
                'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
                'x-sellertool-timestamp': timestamp,
                'x-sellertool-signiture': signature
            };

            axios.get(`${API_HOST}/inbound-stages/uuid/${currentStageUUID}`, {
                headers: headers
            })
                .then(res => {
                    if (res.status === 200 && res.data?.content) {
                        setCurrentStage(res.data.content);
                    }
                })
                .catch(err => {
                    customToast.error(err.response);
                });
        }
    }, [currentStageUUID]);

    useEffect(() => {
        if (!apiInfoContextValueHook?.apiInfo?.apiKey || !apiInfoContextValueHook?.apiInfo?.secretKey || !currentStageUUID) {
            return;
        }

        handleReqFetchWarehousingItems();
    }, [apiInfoContextValueHook?.apiInfo?.apiKey, apiInfoContextValueHook?.apiInfo?.secretKey, currentStageUUID]);

    const handleReqFetchWarehousingItems = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const params = {
            status: 'IN_PROGRESS',
            stageUUID: currentStageUUID
        }

        const warehousingItemsResult = await axios.get(`${API_HOST}/warehousing-items`, {
            headers: headers,
            params: params
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        if (warehousingItemsResult?.content) {
            setWarehousingItems(warehousingItemsResult?.content);
        }
    }

    const handleReqBulkDelete = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        });

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        };

        const body = {
            stageUUID: currentStage?.uuid
        };

        CustomBackdropController().showBackdrop();
        const deleteResult = await axios.delete(`${API_HOST}/warehousing-items/bulk/by-stageUUID`, {
            headers: headers,
            data: body
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                };
            })
            .catch(err => {
                customToast.error(err.response);
            });

        if (deleteResult?.content) {
            handleReqFetchWarehousingItems();
        }
        CustomBackdropController().hideBackdrop();
    };

    const handleOpenScanModal = () => {
        setScanModalOpen(true);
    }

    const handleCloseScanModal = () => {
        setScanModalOpen(false);
    }

    const handleOpenResultModal = () => {
        setResultModalOpen(true);
    }

    const handleCloseResultModal = () => {
        setResultModalOpen(false);
    }

    const handleChangeTargetWaybill = (waybill) => {
        setTargetWaybill(waybill)
    }
    return (
        <>
            <StageSelection
                currentStage={currentStage}
            />
            <St.DeleteButtonField.Container>
                <CustomBlockButton
                    type='button'
                    onClick={() => handleReqBulkDelete()}
                >
                    삭제
                </CustomBlockButton>
            </St.DeleteButtonField.Container>
            <ListMode
                itemList={warehousingItems}
                onOpenScanModal={handleOpenScanModal}
                onOpenResultModal={handleOpenResultModal}
                onChangeTargetWaybill={handleChangeTargetWaybill}
            />
            {resultModalOpen &&
                <ResultMode
                    open={resultModalOpen}
                    onCloseResultModal={handleCloseResultModal}
                    itemList={warehousingItems}
                    targetWaybill={targetWaybill}
                    onOpenScanModal={handleOpenScanModal}
                    onReqFetchWarehousingItems={handleReqFetchWarehousingItems}
                />
            }
            {scanModalOpen &&
                <ScanMode
                    scanModalOpen={scanModalOpen}
                    onCloseScanModal={handleCloseScanModal}
                    itemList={warehousingItems}

                    onOpenResultModal={handleOpenResultModal}
                    onChangeTargetWaybill={handleChangeTargetWaybill}
                />
            }
        </>
    );
};

function ListMode({
    itemList,
    onOpenScanModal,
    onOpenResultModal,
    onChangeTargetWaybill
}) {
    const productCount = itemList?.length;
    const totalCTNCount = itemList?.reduce((prev, current) => (Number(prev) + Number(current?.boxQuantity)), 0);

    const [selectedItems, setSelectedItems] = useState([]);
    const [productName, setProductName] = useState('');

    const handleSelectItem = (item) => {
        VibrationUtils().vibrate();
        setSelectedItems(prev => {
            if (prev.find(r => r.id === item?.id)) {
                return prev.filter(r => r.id !== item.id);
            }

            return [...prev, item];
        })
    }

    const handleChangeProductName = (e) => {
        const value = e.target.value;

        setProductName(value);
    }

    const handleRouteToScanMode = () => {
        VibrationUtils().vibrate();
        onOpenScanModal();
    }

    const handleSelect = (waybillNumber) => {
        onOpenResultModal();
        onChangeTargetWaybill(waybillNumber);
        VibrationUtils().vibrate();
    }

    return (
        <>
            <St.ListMode.Container>
                <St.ListMode.CountBox>
                    <div>
                        총 CTN 수 : {totalCTNCount}
                    </div>
                    <div>
                        총 상품수 : {productCount}
                    </div>
                </St.ListMode.CountBox>
                <St.ListMode.ProductName>
                    <CustomLabelInput>
                        <CustomLabelInput.Input
                            type='text'
                            value={productName || ''}
                            onChange={(e) => handleChangeProductName(e)}
                        />
                        <CustomLabelInput.Label>상품명 입력</CustomLabelInput.Label>
                    </CustomLabelInput>
                </St.ListMode.ProductName>
                {itemList?.filter(r => `${r.warehousingProductName} ${r.warehousingOptionName}`.includes(productName))?.map((item, index) => {
                    const isSelected = selectedItems?.find(r => r.id === item.id) ? true : false;
                    return (
                        <St.ListMode.ItemBox
                            key={item?.id}
                            onClick={() => handleSelectItem(item)}
                            className={`${isSelected ? 'selected' : ''}`}
                        >
                            <div className='flexBox'>
                                <div style={{ flex: 1 }}>
                                    <div className='productName'>
                                        <div>
                                            {item?.warehousingProductName} / {item?.warehousingOptionName}
                                        </div>
                                        <div className='ctns'>{item?.boxQuantity} CTNS</div>
                                    </div>
                                    <div className='detailInfo'>
                                        {item?.productQuantity} 개 / 운송장: {item?.waybillNumber}
                                    </div>
                                </div>
                                <div>
                                    <CustomBlockButton
                                        type='button'
                                        className='selectButton'
                                        onClick={(e) => { e.stopPropagation(); handleSelect(item?.waybillNumber); }}
                                    >
                                        View
                                    </CustomBlockButton>
                                </div>
                            </div>
                        </St.ListMode.ItemBox>
                    );
                })}
                <St.ListMode.FooterBox>
                    <CustomBlockButton
                        type='button'
                        onClick={() => handleRouteToScanMode()}
                    >
                        스캔
                    </CustomBlockButton>
                </St.ListMode.FooterBox>
            </St.ListMode.Container>
        </>
    );
}

function ResultMode({
    open,
    onCloseResultModal,
    itemList,
    targetWaybill,
    onOpenScanModal,
    onReqFetchWarehousingItems
}) {
    const mergingCode = itemList?.find(r => r.waybillNumber.includes(targetWaybill))?.mergingCode;

    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const targetItems = itemList?.filter(r => r.mergingCode === mergingCode);

    const productCount = targetItems?.length;
    const totalCTNCount = targetItems?.reduce((prev, current) => (Number(prev) + Number(current?.boxQuantity)), 0);

    const [selectedItems, setSelectedItems] = useState([]);

    const handleSelectAllItems = () => {
        setSelectedItems(targetItems);
    }

    const handleSelectClearItems = () => {
        setSelectedItems([]);
    }

    const handleSelectItem = (item) => {
        setSelectedItems(prev => {
            if (prev?.find(r => r.id === item.id)) {
                return prev.filter(r => r.id !== item?.id);
            }
            return [...prev, item];
        })
    }

    const handleReqChangeStatusToScanCompleted = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            warehousingItems: selectedItems
        }

        CustomBackdropController().showBackdrop();
        const warehousingItemsResult = await axios.patch(`${API_HOST}/warehousing-items/status/to-scan-completed`, body, {
            headers: headers,
        })
            .then(res => {
                return {
                    res: res,
                    content: res.data?.content
                }
            })
            .catch(err => {
                customToast.error(err.response);
            })

        if (warehousingItemsResult?.content) {
            handleSelectClearItems();
            onReqFetchWarehousingItems();
        }
        CustomBackdropController().hideBackdrop();
    }
    return (
        <>
            <CustomDialog
                open={open}
                onClose={() => onCloseResultModal()}
            >
                <St.ResultMode.Container>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake></CustomDialog.Header.Fake>
                        <CustomDialog.Header.Fake></CustomDialog.Header.Fake>
                        <CustomDialog.Header.Close onClick={() => onCloseResultModal()}></CustomDialog.Header.Close>
                    </CustomDialog.Header>
                    <St.ResultMode.WaybillNumber
                        onClick={() => onOpenScanModal()}
                    >
                        타겟 운송장: {targetWaybill}
                    </St.ResultMode.WaybillNumber>
                    <St.ResultMode.CountBox>
                        <div>
                            총 CTN 수 : {totalCTNCount}
                        </div>
                        <div>
                            총 상품수 : {productCount}
                        </div>
                    </St.ResultMode.CountBox>
                    <St.ResultMode.EventButtonBox>
                        <CustomBlockButton
                            type='button'
                            onClick={() => handleSelectAllItems()}
                        >
                            전체선택
                        </CustomBlockButton>
                        <div
                            className='countBox'
                            onClick={() => handleSelectClearItems()}
                        >{selectedItems?.length} 개 선택됨</div>
                        <CustomBlockButton
                            type='button'
                            onClick={() => handleReqChangeStatusToScanCompleted()}
                        >
                            입고확인
                        </CustomBlockButton>
                    </St.ResultMode.EventButtonBox>
                    {targetItems?.map((item, index) => {
                        const isSelected = selectedItems?.find(r => r.id === item?.id);

                        return (
                            <St.ResultMode.ItemBox
                                key={index}
                                onClick={() => handleSelectItem(item)}
                                className={`${isSelected ? 'isSelected' : ''}`}
                            >
                                <div className='productName'>
                                    <div>
                                        {item?.warehousingProductName} / {item?.warehousingOptionName}
                                    </div>
                                    <div className='ctns'>{item?.boxQuantity} CTNS</div>
                                </div>
                                <div className='detailInfo'>
                                    {item?.productQuantity} 개 / 운송장: {item?.waybillNumber}
                                </div>
                            </St.ResultMode.ItemBox>
                        );
                    })}
                </St.ResultMode.Container>
            </CustomDialog>
        </>
    );
}

function ScanMode({
    itemList,
    scanModalOpen,
    onCloseScanModal,
    onOpenResultModal,
    onChangeTargetWaybill
}) {
    const inputRef = useRef();

    const [mode, setMode] = useState('SCAN') // SCAN, INPUT
    const [waybillNumber, setWaybillNumber] = useState('');

    const handleChangeWaybillNumber = (e) => {
        let value = e.target.value;
        setWaybillNumber(value);
    }

    const handleConfirm = (e) => {
        e.preventDefault();
        if (waybillNumber?.length < 4) {
            customToast.error('운송장번호를 4자리 이상 적어주세요.');
            setWaybillNumber('');
            inputRef.current.focus();
            return;
        }
        const firstTarget = itemList?.find(r => r.waybillNumber.includes(waybillNumber));

        if (!firstTarget) {
            customToast.error('잘못된 운송장번호 입니다.');
            setWaybillNumber('');
            inputRef.current.focus();
            return;
        }

        onOpenResultModal();
        onCloseScanModal();
        onChangeTargetWaybill(waybillNumber)
        // queryParamsHook.setSearchParams({ mode: 'RESULT', mergingCode: firstTarget?.mergingCode }, { replace: true })
    }

    const handleClickBackground = () => {
        inputRef.current.focus();
    }

    const handleChangeMode = (newMode) => {
        setMode(newMode);
    }

    const handleRouteToBack = () => {
        // navigate(-1);
        onCloseScanModal();
    }

    return (
        <>
            <CustomDialog
                open={scanModalOpen}
                onClose={() => handleClickBackground()}
            >
                <St.ScanMode.Container onClick={() => handleClickBackground()}>
                    <form onSubmit={(e) => handleConfirm(e)}>
                        <St.ScanMode.FormField>
                            <div className='modeButtonBox'>
                                <CustomBlockButton
                                    type='button'
                                    onClick={() => handleChangeMode('SCAN')}
                                    className={`${mode === 'SCAN' ? 'active' : ''}`}
                                >스캔모드</CustomBlockButton>
                                <CustomBlockButton
                                    type='button'
                                    onClick={() => handleChangeMode('INPUT')}
                                    className={`${mode === 'INPUT' ? 'active' : ''}`}
                                >입력모드</CustomBlockButton>
                            </div>
                            <CustomLabelInput>
                                <CustomLabelInput.Input
                                    ref={inputRef}
                                    type='text'
                                    value={waybillNumber || ''}
                                    onChange={(e) => handleChangeWaybillNumber(e)}
                                    inputMode={mode === 'SCAN' ? 'none' : 'text'}
                                    autoFocus
                                />
                                <CustomLabelInput.Label>운송장번호</CustomLabelInput.Label>
                            </CustomLabelInput>
                            {mode !== 'SCAN' &&
                                <CustomBlockButton
                                    type='submit'
                                >확인</CustomBlockButton>
                            }
                            <CustomBlockButton
                                type='button'
                                onClick={() => handleRouteToBack()}
                            >뒤로가기</CustomBlockButton>
                        </St.ScanMode.FormField>
                    </form>
                </St.ScanMode.Container>
            </CustomDialog>
        </>
    );
}

const StageSelection = ({
    currentStage
}) => {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const queryParamsHook = useQueryParamsHook();

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [stageList, setStageList] = useState(null);

    const openModal = () => {
        setModalIsOpen(true);
        if (stageList === null) {
            const timestamp = Date.now().toString();
            const signature = SellertoolSignatureUtils().generateSigniture({
                apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
                secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
                timestamp: timestamp
            })

            const headers = {
                'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
                'x-sellertool-timestamp': timestamp,
                'x-sellertool-signiture': signature
            }

            axios.get(`${API_HOST}/inbound-stages`, {
                headers: headers
            })
                .then(res => {
                    if (res.status === 200 && res.data?.content) {
                        setStageList(res.data.content);
                    }
                })
                .catch(err => {
                    customToast.error(err.response);
                });
        }
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const handleStageSelect = (stage) => {
        queryParamsHook.setSearchParams({ stage: stage.uuid });
        closeModal();
    };

    return (
        <St.StageSelection.Container>
            <St.StageSelection.SelectionButton
                type='button'
                onClick={openModal}
            >
                {currentStage ?
                    <div>
                        <div>
                            ({currentStage?.name})
                        </div>
                        <div>
                            {currentStage?.uuid}
                        </div>
                    </div>
                    :
                    <div>
                        스테이지 선택
                    </div>
                }
            </St.StageSelection.SelectionButton>
            <CustomDialog
                open={modalIsOpen}
                onClose={closeModal}
            >
                <St.StageSelection.DialogHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake></CustomDialog.Header.Fake>
                        <CustomDialog.Header.Title>스테이지 선택</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={closeModal}></CustomDialog.Header.Close>
                    </CustomDialog.Header>
                </St.StageSelection.DialogHeader>
                <St.StageSelection.StageList>
                    {stageList?.map((stage, index) => {
                        return (
                            <St.StageSelection.StageItem
                                key={index}
                                onClick={() => handleStageSelect(stage)}
                            >
                                <div className='uuid'>
                                    ({stage.name})<br />{stage.uuid}
                                </div>
                                <div className='createdAt'>
                                    생성일 : {CustomDateUtils().formatDateToYYYYMMDD_HHMMSSFromUnixTime(stage.createdAt)}
                                </div>
                            </St.StageSelection.StageItem>
                        );
                    })}
                </St.StageSelection.StageList>
            </CustomDialog>
        </St.StageSelection.Container>
    );
};